import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {

      app:{
          isLoading: true, // indique s'il faut afficher le PageLoaderComp
          StoreInitToken: null,   // indique que le store a été hydraté et non null (comme ça peut être le cas suite à un rechargement de page par exemple) voir userInitialHydration().
          themeToDisplay: null, // le thème à afficher (light | dark)

      },


    // Global ---------------------------------------------------------------
      organization: {
        slug:  null,
          name: null,
      },

      user: {
          slug: null,
          gender: null,
          firstname :null,
          name :null,
          email:null,
          currentAccountEmail: null, // la valeurs de l'email du compte (n'est pas mappé à un setter  sert uniquement dans la validation du UserSettingEmailComp pour valider une adresse email déjà éxistante mais qui est celle du compte actuel.)
          timezone: null,
          workspaces: [{}], // des objets workspaces auxquels user appartient
          // activeWorkspace: {}, // l'objet worspace auquel user est connecté // @commenté car pour le moment dans l'appli le activeWorkspace est récupéré depuis le cookie de session dans $auth @todo à décommenter/supprimer lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
          preferedTheme: null, // (light | dark | system) le thème préféré de l'utilisateur
          hourRate: null, // int le taux horaire de l'utilisateur

      },

      currentTimeRecord : null, // le dernier TimeRecord de l'utilisateur ou celui en cours (sans timeOut) //@todo refactorer dans partie avec nom composant !


    // Composant AppNavbarComp ----------------------------------------------
    AppNavbarComp: {
      menu:{
        isOpened: true,         // Indique si le menu est ouvert
      }
    },

    // Composant GlobalNotificationComp --------------------------------------
    GlobalNotificationComp: {
      isVisible: false,
      color: '',                 // la couleur de la notification (basé sur bulma https://bulma.io/documentation/elements/notification/#colors)
      message: '',               // le message à afficher dans la notification
      duration: null,         // la durée d'affichage (en ms)
    },

    // Composant ModalTermslComp ---------------------------------------------
      ModalTermslComp: {
          isVisible: false,            // la visibilité de la modal
    },

      // Composant MyRecentActivityComp ---------------------------------------------
      MyRecentActivityComp: {
          timerecords: [],            // un tableau de timerecords
      },

      // Composant TaskTimerecordListComp ---------------------------------------------
      TaskTimerecordListComp: {
          timerecords: [],            // un tableau de timerecords
      },

      // Composant TimerecordsActivityChartsComp ---------------------------------------------
      TimerecordsActivityChartsComp: {

             periodName: '', // le nom de la période à afficher dans le chart
             durations: {
                 // les datas du chart par période
                 thisWeek: [],
                 thisMonth: [],
                 lastWeek: [],
                 lastMonth: [],
             }
      },
      // Composant ModalTimerecordsEditionComp ---------------------------------------------
      ModalTimerecordsEditionComp: {
          isVisible: false,            // la visibilité de la modal
          timerecord: {}, // le tr à éditer
      },

      // Composant ModalTaskTimerecordsEditionComp ---------------------------------------------
      ModalTaskTimerecordsEditionComp: {
          isVisible: false,            // la visibilité de la modal
          timerecord: {}, // le tr à éditer
          isCurrent: false, // indique si le timerecord à éditer est celui en cours (timeOut = null)
      },

      // Composant TimeTrackingView ---------------------------------------------
      TimeTrackingView: {
          currentTaskTimerecord: null, // le taskTimerecord en cours
          projectsGroupedByClient: null, // [] un array d'objet Project groupé par Client
          suggestedTr: { // un objet pour stocker les valeurs relatives au SuggestedTimerecordsComp
            timerecords: [], // les timerecords suggérés dans SuggestedTimerecordsComp
            indexCurrentActive : null, // int  l'index de la suggestion actuellement affichée comme focusée dans SuggestedTimerecordsComp
          }

      },

      // Composant ProjectsView ---------------------------------------------
      ProjectsView: {
          projects: null, // [] Un array d'objet project
      },
      // Composant ClientsView ---------------------------------------------
      ClientsView: {
          clients: null, // [] Un array d'objet clients
      },

      // Composant TagsView ---------------------------------------------
      TagsView: {
          tags: null, // [] Un array d'objet tag
      },
      // Composant ReportsView ---------------------------------------------
      ReportView: {
          currentPeriod: { // la période sélectionnée dans la view
            name: null,
          }

          // les critères de filtrage à appliquer
          ,filterRules: {
              project: { // les critères de filtrage de projet
                  noRelated:null, // @todo init à false ?  (null/true/false) indique si noRelatedFilter est coché dans le filtre
                  projects2Filter:[] // un tableau de slug de projets (@see projectsFiltered dans ProjectFilterComp.vue)
              },
              tag: { // les critères de filtrage de tag
                  noRelated:null, // @todo init à false ?  (null/true/false) indique si noRelatedFilter est coché dans le filtre
                  tags2Filter:[] // un tableau de slug de tags (@see tagsFiltered dans TagFilterComp.vue)
              },
              client: { // les critères de filtrage de client
                  noRelated:null, // (null/true/false) indique si noRelatedFilter est coché dans le filtre
                  clients2Filter:[] // un tableau de slug de client (@see clientsFiltered dans ClientFilterComp.vue)
              },
              billable:{ // les critères de filtrage facturable /non facturable
                  billableFilter:null, // (null/true/false) indique si les tr facturables doivent être inclus
                  nonBillableFilter:null, // (null/true/false) indique si les tr non facturables doivent être inclus
              },
              taskName:{  // les critères de filtrage taskName
                  description: null,// string Le valeur de taskName sur laquelle filtrer les timerecords
                  noRelated:null, // (null/true/false) indique si noRelatedFilter est coché dans le filtre

              }
          }

    },

      // Composant UsersView ---------------------------------------------
      UsersView: {
          users: null, // [] Un array d'objet user
      },


      // Composant SubscriptionView ---------------------------------------------
      SubscriptionView: {
          workspace: {
              trialStarted : null, // boolean indiquant si un trial sur un plan payant a été démarré pour le workspace ( idéalement j'aurais aimé récupérer et stocker cette infos au login, @refactorer ?)
              trialEnd: null, // la date de fin du trial
          }
          // users: null, // [] Un array d'objet user
      },

},
  mutations: {
      // App --------------------------------------------------------
      UpdateAppIsLoading(state,value) {state.app.isLoading=value},
      UpdateAppStoreInitToken(state, value) {state.app.StoreInitToken= value;},
      UpdateThemeToDisplay(state, value) {state.app.themeToDisplay= value;},

      // Global Organization --------------------------------------------------------
      UpdateOrganization(state, value) {state.organization= value;},
      UpdateOrganizationSlug(state, value) {state.organization.slug= value;},
      UpdateOrganizationName(state, value) {state.organization.name= value;},

      // Global User  --------------------------------------------------------
      UpdateUser(state, value) {state.user= value;},
      UpdateUserSlug(state, value) {state.user.slug= value;},
      UpdateUserGender(state, value) {state.user.gender= value;},
      UpdateUserFirstname(state, value) {state.user.firstname= value;},
      UpdateUserName(state, value) {state.user.name= value;},
      UpdateUserEmail(state, value) {state.user.email= value;},
      UpdateUserCurrentAccountEmail(state, value) {state.user.currentAccountEmail= value;},
      UpdateUserCurrentTimeRecord(state, value) {state.currentTimeRecord= value;},
      // UpdateUserActiveWorkspace(state, value) {state.user.activeWorkspace= value;}, @todo à décommenter/supprimer lors de ticket #290 (https://gitlab.com/ousmane1/kronocloud/-/issues/290)
      UpdateUserPreferedTheme(state, value) {state.user.preferedTheme= value;},


      // Composant AppNavbarComp ----------------------------------------------
      UpdateAppNavBarCompIsOpened(state, value) {state.AppNavbarComp.menu.isOpened = value;},

      // Composant GlobalNotificationComp --------------------------------------------
      UpdateGlobalNotificationCompVisibility(state, value) {state.GlobalNotificationComp.isVisible = value;},
      UpdateGlobalNotificationComp(state, value) {state.GlobalNotificationComp = value;},

      // Composant ModalComp --------------------------------------------
      UpdateModalTermsComp(state, value) {state.ModalTermslComp = value;},

      // Composant MyRecentActivityComp --------------------------------------------
      UpdateMyRecentActivityComp(state, value) {state.MyRecentActivityComp = value;},

      // Composant TaskTimerecordListComp --------------------------------------------
      UpdateTaskTimerecordListComp(state, value) {state.TaskTimerecordListComp = value;},

      // Composant ModalTimerecordsEditionComp --------------------------------------------
      UpdateModalTimerecordsEditionComp(state, value) {state.ModalTimerecordsEditionComp = value;},

      UpdateModalTaskTimerecordsEditionComp(state, value) {state.ModalTaskTimerecordsEditionComp = value;},

      /**
       *
       * @param state
       * @param value  {objet} { periodName( nom de la période), data (les durées)}
       * @constructor
       */
      UpdateTimerecordsActivityChartsCompDurationsByPeriod(state, value) {
          state.TimerecordsActivityChartsComp.durations[value.periodName] = value.data
          state.TimerecordsActivityChartsComp.periodName = value.periodName
      },
      UpdateTimerecordsActivityChartsCompPeriod2Display(state, value) {
          state.TimerecordsActivityChartsComp.periodName= value
      },

      UpdateTimeTrackingViewCurrentTask(state, value) {
          state.TimeTrackingView.currentTaskTimerecord = value
      },

      UpdateTimeTrackingSuggestedTrTimerecords(state, value) {
          state.TimeTrackingView.suggestedTr.timerecords = value
      },

      UpdateTimeTrackingSuggestedTrIndexCurrentActive(state, value) {
          state.TimeTrackingView.suggestedTr.indexCurrentActive = value
      },

      UpdateTimeTrackingViewProjectsGroupedByClient(state, value) {
          state.TimeTrackingView.projectsGroupedByClient = value
      },
      UpdateProjectsViewProjects(state, value) {
          state.ProjectsView.projects = value
      },
      UpdateClientsViewClients(state, value) {
          state.ClientsView.clients = value
      },

      UpdateTagsViewTags(state, value) {
          state.TagsView.tags = value
      },

      UpdateReportsViewFilterRulesProject(state, value) {
          state.ReportView.filterRules.project = value
      },

      UpdateReportsViewFilterRulesTag(state, value) {
          state.ReportView.filterRules.tag = value
      },

      UpdateReportsViewFilterRulesTaskName(state, value) {
          state.ReportView.filterRules.taskName = value
      },

      UpdateReportsViewFilterRulesClient(state, value) {
          state.ReportView.filterRules.client = value
      },
      UpdateReportsViewFilterRulesBillable(state, value) {
          state.ReportView.filterRules.billable = value
      },
      UpdateUsersViewUsers(state, value) {
          state.UsersView.users = value
      },
      UpdateSubscriptionViewWorkspaceTrialStarted(state, value) {
          state.SubscriptionView.workspace.trialStarted = value
      },
      UpdateSubscriptionViewWorkspaceTrialEnd(state, value) {
          state.SubscriptionView.workspace.trialEnd = value
      }
  },
  actions: {

  },
    getters: {
        user: state => {
            return state.user
        }
    }
})
